import { useNavigate } from "react-router-dom";
import { useState, useCallback } from "react";
import { getIdeProjects } from "../services/ide-apis";
import { Link } from "react-router-dom";
import { global_var } from "../services/cs-lab-config";
import { useParams } from 'react-router-dom';
import {
  message,
  Card,
  List,
  Avatar,
  Typography,
  Divider,
  Badge,
  Row,
  Col,
  Empty,
} from "antd";
import {
  StarFilled,
  LeftOutlined,
  CheckCircleFilled,
} from "@ant-design/icons";
import {
  formatDate,
  getIdeProjectLogo,
  getEvaluationStatusColor,
  getIdeProjectTypeMetaData,
  trackEvent,
  getEvaluationStatusName,
} from "./utils/util-functions";
import ProjectFilters from "./utils/project-filters";
import CardSkeleton from "./utils/card-skeleton";
import  noDataImage  from '../assets/images/No notifcations.png'
import { ReactComponent as PendingIcon } from './../assets/logos/pending.svg';
import { ReactComponent as ResubmissionIcon } from './../assets/logos/resubmission.svg';
import { ReactComponent as UserIcon } from './../assets/logos/evaluate user.svg';
import { ReactComponent as ClassIcon } from './../assets/logos/class icon.svg';
import { ReactComponent as ClockIcon } from './../assets/logos/clock icon.svg';

const EvaluateProjects = () => {
  document.title = 'CS Lab | Evaluate';
  const navigate = useNavigate();

  const [pageno, setPageNumber] = useState(0);
  const [projects, setProjects] = useState([]);
  const [totalProjectsCount, setTotalProjectsCount] = useState(0);
  const [projectLoading, setProjectLoading] = useState(false);
  const { resourceId, labQuestionMappingId } = useParams();

  function handleEvaluateProject(projectObj) {
    const projectMetaData = getIdeProjectTypeMetaData(
      projectObj.projectLanguage
    );

    trackEvent("evaluate_projects_page_view_button_clicked", {
      ide_project_stack_name: projectObj.projectLanguage,
    });

    if (projectMetaData ? projectMetaData.route : false) {
      const fkResourceIdParam = projectObj.fkResourceId ? projectObj.fkResourceId : '';
      global_var.EvaluateProjectsPageNo = pageno
      if (projectObj.projectLanguage === "sql2") {
        navigate(`${projectMetaData.route}${projectObj.queryId}?fkResourceId=${fkResourceIdParam}`);
      } else if (projectObj.projectLanguage === "vc3") {
        navigate(projectMetaData.route + projectObj._id + '?isEval=true&fkResourceId=' + fkResourceIdParam);
      } else {
        navigate(projectMetaData.route + projectObj._id);
      }
    } else {
      message.info("Coming soon.");
    }
  }

  const filtersChanged = useCallback((filters) => {
    setProjectLoading(true);

    const reqObj = {
      ...filters,
      fkCompanyId: global_var.company_id,
      submittedForEvaluation: true,
      limitCount: 12,
      from: "csLab"
    };

    setPageNumber(reqObj.pageNo)
    reqObj.pageNo = reqObj.pageNo - 1;
    delete global_var.EvaluateProjectsPageNo

    if(resourceId){
      reqObj.resourceId = resourceId;
    }
    if(labQuestionMappingId){
      reqObj.labQuestionMappingId = labQuestionMappingId;
    }
    getIdeProjects(reqObj).then((response) => {
      setProjectLoading(false);
      response = response.data;

      if (response.statusCode === 200) {
        setProjects(response.projects);
        setTotalProjectsCount(response.totalProjectsCount);
      } else {
        message.error(response.message);
      }
    });
  }, [labQuestionMappingId, resourceId]);

  return (
    <>
      <Row className="mt-4">
        <Col
          className="col d-flex align-items-center"
          justify="space-evenly"
          align="middle"
        >
          <Link onClick={() => navigate(-1)}  className="mr-2">
          <span className="mt-2  back-button">
            <LeftOutlined  className=" h4" style={{ color: '#000000' }} />
          </span>
          </Link>
          <span className="m-1 h4 ">Evaluate Projects</span>
        </Col>
      </Row>
      <Divider className="mt-1" style={{backgroundColor:"#D7BEF7"}}/>

      <ProjectFilters
        filtersChanged={filtersChanged}
        totalProjectsCount={totalProjectsCount}
        hideClassFilter ={global_var.needClass && (global_var.role_id !== global_var.STUDENT_ROLE_ID) ? false : true} 
        hideDivisionFilter ={global_var.needDivision && (global_var.role_id !== global_var.STUDENT_ROLE_ID) ? false : true}
        hideAcademicYearFilter = {true}
      />

      <div className="row mx-2 left-padding">
        <div className="col">
          {projectLoading ? (
            <List
              grid={{
                gutter: 10,
                xs: 1,
                sm: 2,
                md: 3,
                lg: 3,
                xl: 3,
                xxl: 3,
              }}
              dataSource={Array(8).fill(0)}
              renderItem={() => (
                <List.Item className="mr-2 mb-5">
                  <CardSkeleton />
                </List.Item>
              )}
            />
          ) : (
            <List
              locale={{
                emptyText: (
                  <Empty
                    image={noDataImage}
                    description={
                      <div>
                        <p className="poppins-regular" style={{fontSize:'18px'}}>No Projects yet!</p>
                      </div>
                    }
                  />
                ),
              }}
              grid={{
                gutter: 10,
                xs: 1,
                sm: 2,
                md: 3,
                lg: 3,
                xl: 3,
                xxl: 3,
              }}
              dataSource={projects}
              renderItem={(projectObj) => (
                <List.Item className="mr-2 mb-3">
                  <Card onClick={() => handleEvaluateProject(projectObj)}
                    title={
                      <div className="mt-2" style={{ display: 'flex', alignItems: 'center' }}>
                        <Badge style={{ color: "#0057ff" }} count={projectObj.showInPortFolio ? <StarFilled style={{color:'#FFC200'}}/> : 0}>
                          <Avatar src={getIdeProjectLogo(projectObj.projectLanguage)} />
                        </Badge>
                        <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 8 }}>
                          <Typography.Text ellipsis={{ tooltip: projectObj.name }} className="poppins-regular">{projectObj.name}</Typography.Text>
                          <Typography.Text ellipsis={{ tooltip: projectObj.projectLanguage }} 
                          className="poppins-light" style={{color:'#6E6C6C',fontSize:'12px'}}>{ projectObj.projectLanguage }</Typography.Text>
                        </div>
                      </div>
                    }
                    bordered={false} 
                    className={`glass specific-card evaluate-card ${projectObj.evaluationStatus === 'Evaluated' ? "mobile-evaluate-card" : ""}`}
                    style={{ cursor: 'pointer'}}
                    >
                      <Divider className="mt-0 mb-1"></Divider>
                      <p>
                        <UserIcon className="me-1" />
                        <Typography.Text className="text-midgrey poppins-regular" style={{fontSize:'12px'}}
                          ellipsis={{
                            tooltip: projectObj.studentName,
                          }}
                        >
                          {projectObj.studentName}
                        </Typography.Text>
                      </p>
                      {projectObj.fkClassName && (
                        <p>
                          <ClassIcon className="me-1" />
                          <Typography.Text className="text-midgrey poppins-regular" style={{fontSize:'12px'}}>
                            {projectObj.fkClassName +
                              " - " +
                              projectObj.fkDivisionName}
                          </Typography.Text>
                        </p>
                      )}
                      <p>
                        <ClockIcon className="me-1" />
                        <Typography.Text className="text-midgrey poppins-regular" style={{fontSize:'12px'}}
                          ellipsis={{
                            tooltip: formatDate(projectObj.createdDate),
                          }}
                        >
                          {formatDate(projectObj.createdDate)}
                        </Typography.Text>
                      </p>
                      <p>  
                        <span className='poppins-medium'
                          style={{color:getEvaluationStatusColor(projectObj.evaluationStatus),fontSize:'12px'}}
                        > 
                          {projectObj.evaluationStatus === 'Ask for resubmission' ? <ResubmissionIcon /> :
                            projectObj.evaluationStatus === 'Evaluated' ? <CheckCircleFilled style={{ color: "#2AC14E", borderRadius: '4px', padding: '2px' }} /> :
                            <PendingIcon />}
                          {getEvaluationStatusName(projectObj.evaluationStatus)}
                        </span>
                      </p>
                    </Card>
                </List.Item>
              )}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default EvaluateProjects;
